import { useGlobal } from "../context/ContenedorGlobal";
import { useState, useEffect } from "react";
import "../styles/Formularios.css";
import InputPuertos from "./InputPuertos";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import { useApiFetch } from "../utils/apiFetch";
import InputNombrePatch from "./InputNombrePatch";

function RegistrarPatchP() {
    const { setModuloActual, setSubModuloActual, permisos, logout } = useGlobal();
    const [patch, setPatch] = useState("");
    const [puertos, setPuertos] = useState("");
    const [idSede, setIdSede] = useState("");
    const [idEdificio, setIdEdificio] = useState("");
    const [idNivel, setIdNivel] = useState("");
    const [descPatch, setDescPatch] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [success, setSuccess] = useState(false);
    const apiFetch = useApiFetch();

    const tienePermisoRegistrar = permisos.includes(35); // id_permiso=35; "Registrar Patch Panel"

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje("");

        // Validación de campos obligatorios
        if (!patch || !puertos || !idSede || !idEdificio || !idNivel || !descPatch) {
            return setMensaje("Todos los campos son obligatorios.");
        }

        // Envio de datos para crear la tabla y registrar el patch panel en su tabla respectiva
        try {

            const data = await apiFetch("registrar_patch.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    patch,
                    puertos: Number(puertos),
                    idSede,
                    idEdificio,
                    idNivel,
                    descPatch
                })
            }, logout);

            if (data.status === "ok") {
                setMensaje(data.message);
                setSuccess(true);
                setTimeout(() => {
                    setModuloActual("Red");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setMensaje("\u274C " + (data.message || "Error al registrar el patch panel."));
            }
        } catch (err) {
            setMensaje("Error de conexión con el servidor: " + err.message);
        }
    };

    useEffect(() => {
        if (mensaje) {
            const timer = setTimeout(() => {
                setMensaje("");
                setSuccess(false);
            }, 3000);

            return () => clearTimeout(timer); // Evita fugas si cambia antes
        }
    }, [mensaje]);

    if (!tienePermisoRegistrar) {
        return <p>Acceso denegado. No tiene permiso para registrar patch panels.</p>;
    }

    // Captura de datos reutilizando componentes
    return (
        <div className="sesion-form">

            {mensaje && <div className={success ? "success" : "error"}>{mensaje}</div>}

            <form onSubmit={handleSubmit}>

                <InputNombrePatch
                    value={patch}
                    setValue={setPatch}
                    label="Nombre del patch panel"
                    placeholder="pp1_ep_pb"
                    title="Respete la nomenclatura, Formato: pp1_ep_pb"
                />

                <InputPuertos
                    puertos={puertos}
                    setPuertos={setPuertos}
                    label="Número de puertos"
                    readOnly={false}
                />

                <InputSelectGenerico
                    idSeleccionado={idSede}
                    setIdSeleccionado={setIdSede}
                    label="Sede"
                    apiUrl={`consultar_sedes.php`}
                    valueField="id_sede"
                    displayField="acronimo"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione una sede"
                />

                <InputSelectGenerico
                    idSeleccionado={idEdificio}
                    setIdSeleccionado={setIdEdificio}
                    label="Edificio"
                    apiUrl={`consultar_edificios.php`}
                    valueField="id_edificio"
                    displayField="edificio"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un edificio"
                />

                <InputSelectGenerico
                    idSeleccionado={idNivel}
                    setIdSeleccionado={setIdNivel}
                    label="Nivel"
                    apiUrl={`consultar_niveles.php`}
                    valueField="id_nivel"
                    displayField="nivel"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un piso o nivel"
                />

                <InputGenerico
                    value={descPatch}
                    setValue={setDescPatch}
                    label="Descripción del patch panel"
                    allowedChars="a-zA-Z0-9 _\-.,áéíóúÁÉÍÓÚñÑ"
                    maxLength={255}
                    placeholder="Escriba su texto aquí"
                    title="Máximo 255 caracteres"
                />

                <div className="form-buttons">
                    <button type="submit" disabled={success}>Registrar</button>
                </div>
            </form>
        </div>
    );
}

export default RegistrarPatchP;